// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/setting_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PersonalSettings } from "./setting_model_pb";
import { file_bffuser_v1_setting_model } from "./setting_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/setting_service.proto.
 */
export const file_bffuser_v1_setting_service: GenFile = /*@__PURE__*/
  fileDesc("CiBiZmZ1c2VyL3YxL3NldHRpbmdfc2VydmljZS5wcm90bxIKYmZmdXNlci52MSIcChpHZXRQZXJzb25hbFNldHRpbmdzUmVxdWVzdCJNChtHZXRQZXJzb25hbFNldHRpbmdzUmVzcG9uc2USLgoIc2V0dGluZ3MYASABKAsyHC5iZmZ1c2VyLnYxLlBlcnNvbmFsU2V0dGluZ3Mi5gEKHVVwZGF0ZVBlcnNvbmFsU2V0dGluZ3NSZXF1ZXN0EjYKCHNldHRpbmdzGAEgASgLMhwuYmZmdXNlci52MS5QZXJzb25hbFNldHRpbmdzQga6SAPIAQESNwoLdXBkYXRlX21hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrQga6SAPIAQESPAoTZXhwZWN0ZWRfdXBkYXRlZF9hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBAUIWChRfZXhwZWN0ZWRfdXBkYXRlZF9hdCJQCh5VcGRhdGVQZXJzb25hbFNldHRpbmdzUmVzcG9uc2USLgoIc2V0dGluZ3MYASABKAsyHC5iZmZ1c2VyLnYxLlBlcnNvbmFsU2V0dGluZ3My7QEKDlNldHRpbmdTZXJ2aWNlEmgKE0dldFBlcnNvbmFsU2V0dGluZ3MSJi5iZmZ1c2VyLnYxLkdldFBlcnNvbmFsU2V0dGluZ3NSZXF1ZXN0GicuYmZmdXNlci52MS5HZXRQZXJzb25hbFNldHRpbmdzUmVzcG9uc2UiABJxChZVcGRhdGVQZXJzb25hbFNldHRpbmdzEikuYmZmdXNlci52MS5VcGRhdGVQZXJzb25hbFNldHRpbmdzUmVxdWVzdBoqLmJmZnVzZXIudjEuVXBkYXRlUGVyc29uYWxTZXR0aW5nc1Jlc3BvbnNlIgBCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bffuser_v1_setting_model, file_buf_validate_validate, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * GetPersonalSettingsRequest has no fields because member_id is derived from
 * the eauth session by the BFF handler.
 *
 * @generated from message bffuser.v1.GetPersonalSettingsRequest
 */
export type GetPersonalSettingsRequest = Message<"bffuser.v1.GetPersonalSettingsRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetPersonalSettingsRequest.
 * Use `create(GetPersonalSettingsRequestSchema)` to create a new message.
 */
export const GetPersonalSettingsRequestSchema: GenMessage<GetPersonalSettingsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_setting_service, 0);

/**
 * @generated from message bffuser.v1.GetPersonalSettingsResponse
 */
export type GetPersonalSettingsResponse = Message<"bffuser.v1.GetPersonalSettingsResponse"> & {
  /**
   * @generated from field: bffuser.v1.PersonalSettings settings = 1;
   */
  settings?: PersonalSettings;
};

/**
 * Describes the message bffuser.v1.GetPersonalSettingsResponse.
 * Use `create(GetPersonalSettingsResponseSchema)` to create a new message.
 */
export const GetPersonalSettingsResponseSchema: GenMessage<GetPersonalSettingsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_setting_service, 1);

/**
 * UpdatePersonalSettingsRequest applies a partial update to PersonalSettings.
 * organization_id and member_id are derived from the eauth session by the BFF
 * handler. update_mask controls which fields are written. Accepted paths are
 * the top-level field names of PersonalSettings:
 *
 * 	theme, monitoring_unit, show_ticker, business_areas, stack_order,
 * 	order_book_column_order
 *
 * Specifying business_areas or stack_order replaces the entire array.
 * Unknown paths are rejected by the backend with CodeInvalidArgument.
 *
 * @generated from message bffuser.v1.UpdatePersonalSettingsRequest
 */
export type UpdatePersonalSettingsRequest = Message<"bffuser.v1.UpdatePersonalSettingsRequest"> & {
  /**
   * Settings payload. The client must populate every field (= strict
   * protovalidate rules apply to the whole message); only fields covered
   * by update_mask are written by the backend usecase. See TODO(#556)
   * for the planned migration to true partial payload.
   *
   * @generated from field: bffuser.v1.PersonalSettings settings = 1;
   */
  settings?: PersonalSettings;

  /**
   * Paths to update. Must not be empty. Each path must be a top-level
   * field name of PersonalSettings (no nested dot-separated paths, no
   * array indexing).
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;

  /**
   * Optimistic-lock baseline from the latest Get/Update response. Optional
   * for expand compatibility with already-open older SPA sessions (#11769).
   *
   * @generated from field: optional google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdatePersonalSettingsRequest.
 * Use `create(UpdatePersonalSettingsRequestSchema)` to create a new message.
 */
export const UpdatePersonalSettingsRequestSchema: GenMessage<UpdatePersonalSettingsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_setting_service, 2);

/**
 * @generated from message bffuser.v1.UpdatePersonalSettingsResponse
 */
export type UpdatePersonalSettingsResponse = Message<"bffuser.v1.UpdatePersonalSettingsResponse"> & {
  /**
   * The full PersonalSettings after the update has been applied.
   *
   * @generated from field: bffuser.v1.PersonalSettings settings = 1;
   */
  settings?: PersonalSettings;
};

/**
 * Describes the message bffuser.v1.UpdatePersonalSettingsResponse.
 * Use `create(UpdatePersonalSettingsResponseSchema)` to create a new message.
 */
export const UpdatePersonalSettingsResponseSchema: GenMessage<UpdatePersonalSettingsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_setting_service, 3);

/**
 * SettingService aggregates Connect RPCs for the settings tabs (設定画面)
 * consumed by the frontend. Currently covers the 個人設定 (personal) tab only;
 * SupplyDemand / BidLimits / DataServices tabs will be added as future RPCs.
 *
 * member_id is never exposed to the frontend; the BFF handler derives it from
 * the eauth session.
 *
 * @generated from service bffuser.v1.SettingService
 */
export const SettingService: GenService<{
  /**
   * GetPersonalSettings returns the personal settings for the current member
   * (derived from eauth session).
   *
   * @generated from rpc bffuser.v1.SettingService.GetPersonalSettings
   */
  getPersonalSettings: {
    methodKind: "unary";
    input: typeof GetPersonalSettingsRequestSchema;
    output: typeof GetPersonalSettingsResponseSchema;
  },
  /**
   * UpdatePersonalSettings applies an update to the personal settings.
   * update_mask.paths lists the fields the user just edited; the backend
   * usecase writes only those columns. Today the client must still populate
   * every field on settings (= PersonalSettings carries strict protovalidate
   * rules); see PersonalSettings comment in setting_model.proto and TODO(#556)
   * for the planned migration to true partial payload. The BFF handler
   * passes the update_mask through to the backend without reconstruction.
   *
   * @generated from rpc bffuser.v1.SettingService.UpdatePersonalSettings
   */
  updatePersonalSettings: {
    methodKind: "unary";
    input: typeof UpdatePersonalSettingsRequestSchema;
    output: typeof UpdatePersonalSettingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_setting_service, 0);

